import React, { Component } from 'react'

import './ChampForm.css'

/**
 * Modules
 */
import { Form, Input, DatePicker, Button, message } from 'antd'
import TextArea from '../../../../node_modules/antd/lib/input/TextArea'
import moment from 'moment'
import { createChamp as sharedCreateChamp, updateChamp as sharedUpdateChamp } from '../../../utils/champsFunctions';

class ChampForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            champAddObjectFile: null,
            champAddObjectDoc: null,
            addButtonLoading: false,
            editButtonLoading: false,
            initialValue: [{}, {}, {}, {}],
            isUpdate: false,
            champToEdit: {},
        }
    }

    componentDidMount = () => {
        this.checkIfUpdate(this.props)
    }

    componentWillReceiveProps = (nextProps) => {
        this.checkIfUpdate(nextProps)
    }

    /* Method to check if form is to register or update */
    checkIfUpdate = (props) => {
        if (props.champToEdit) {
            this.setState({
                initialValue: [
                    { initialValue: props.champToEdit.nome },
                    { initialValue: props.champToEdit.descricao },
                    { initialValue: props.champToEdit.observacao },
                    { initialValue: moment(props.champToEdit.data) }
                ],
                isUpdate: true,
                champToEdit: props.champToEdit
            })
        }
    }

    chooseFile = () => {
        document.getElementById('selectChampFile').click()
    }

    getFile = (file) => {
        this.setState({
            champAddObjectFile: file.target.files[0]
        })
    }

    removeFile = () => {
        this.setState({
            champAddObjectFile: undefined
        })
    }

    createChamp = async (values) => {
        this.setState({ addButtonLoading: true })
        if (values.name) {
            let data = new Date(values.date).getTime()

            // Create champ in firebase
            const callbackCreatedChamp = await sharedCreateChamp(
                {
                    nome: values.name,
                    descricao: values.description,
                    data: data,
                    observacao: values.obs,
                    wasDeleted: false,
                    momentOfCreation: new Date().getTime(),
                    img: '',
                    doc: '',

                    registrationStatus: 'inProgress',
                    confrontationPerTime: 4,
                    confrontationTime: 10,
                    startChamp: 9
                },
                this.state.champAddObjectFile,
                this.state.champAddObjectDoc,
            );

            if (!callbackCreatedChamp.error) {
                /* Clear form */
                this.props.form.resetFields();
                this.setState({
                    addButtonLoading: false,
                    champAddObjectFile: null,
                    champAddObjectDoc: null
                });

                this.props.closeChampAddDialog();
            } else {
                this.setState({ addButtonLoading: false });
                message.error(callbackCreatedChamp.message);
            }
        } else {
            this.setState({ addButtonLoading: false });
            message.error('Nome do campeonato é obrigatório');
        }
    }

    editChamp = async (values) => {
        this.setState({ editButtonLoading: true })
        if (values.name) {

            let data = new Date(values.date).getTime()
            /* Update champ in firebase */
            const callbackUpdatedChamp = await sharedUpdateChamp(
                this.state.champToEdit.__key,
                {
                    nome: values.name,
                    descricao: values.description,
                    data: data,
                    observacao: values.obs,
                    wasDeleted: false,
                },
                this.state.champAddObjectFile,
                this.state.champAddObjectDoc,
            );

            if (!callbackUpdatedChamp.error) {
                /* Clear form */
                this.props.form.resetFields()
                this.setState({
                    editButtonLoading: false,
                    champAddObjectFile: null,
                    champAddObjectDoc: null
                });

                this.props.closeChampEditDialog();
            } else {
                this.setState({ editButtonLoading: false });
                message.error(callbackUpdatedChamp.message);
            }
        } else {
            this.setState({ editButtonLoading: false });
            message.error('Nome do campeonato é obrigatório');
        }
    }

    // Edital methods
    chooseDoc = () => {
        document.getElementById('selectChampDoc').click()
    }

    getDoc = (file) => {
        this.setState({
            champAddObjectDoc: file.target.files[0]
        })
    }

    removeDoc = () => {
        this.setState({
            champAddObjectDoc: undefined
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form>
                    <Form.Item>
                        {getFieldDecorator('name', this.state.initialValue[0])(
                            <Input placeholder='Nome do campeonato' className='sharedInput browser-default' />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('description', this.state.initialValue[1])(
                            <Input placeholder='Descrição do campeonato' className='sharedInput browser-default' />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('obs', this.state.initialValue[2])(
                            <TextArea placeholder='Observações' rows={2} />
                        )}
                    </Form.Item>

                    <Form.Item style={{ float: 'left', width: '49%' }}>
                        {getFieldDecorator('date', this.state.initialValue[3])(
                            <DatePicker style={{ width: '100%' }} format='DD/MM/YYYY' placeholder='Data' className='browser-default date-input' />
                        )}
                    </Form.Item>

                    <input id='selectChampFile' type='file' style={{ display: "none" }} onChange={(input) => this.getFile(input)} />
                    {this.state.champAddObjectFile ?
                        <div className='sharedFileField' style={{ height: '31px', lineHeight: '31px', marginTop: '4px', marginLeft: '2%' }}>
                            {this.state.champAddObjectFile.name}
                            <div
                                className='sharedClearFileButton'
                                onClick={this.removeFile}
                            >X</div>
                        </div>
                        :
                        <Button
                            onClick={() => this.chooseFile()}
                            style={{ width: '49%', float: 'left', marginTop: '4px', marginLeft: '2%' }}
                            htmlType='button'
                        >
                            Enviar foto
                        </Button>
                    }

                    <div style={{ clear: 'both' }}></div>

                    <input id='selectChampDoc' type='file' style={{ display: "none" }} onChange={(input) => this.getDoc(input)} />
                    {this.state.champAddObjectDoc ?
                        <div className='sharedFileField' style={{ height: '31px', lineHeight: '31px', marginBottom: '20px', width: '100%' }}>
                            {this.state.champAddObjectDoc.name}
                            <div
                                className='sharedClearFileButton'
                                onClick={this.removeDoc}
                            >X</div>
                        </div>
                        :
                        <Button
                            onClick={() => this.chooseDoc()}
                            style={{ width: '100%', float: 'left', marginBottom: '20px' }}
                            htmlType='button'
                        >
                            Incluir edital
                        </Button>
                    }

                    {this.state.isUpdate ?
                        <Button
                            htmlType='button'
                            onClick={() => this.editChamp(this.props.form.getFieldsValue())}
                            type='primary'
                            style={{ width: '100%' }}
                            loading={this.state.editButtonLoading}
                        >
                            Atualizar
                        </Button>
                        :
                        <Button
                            htmlType='button'
                            onClick={() => this.createChamp(this.props.form.getFieldsValue())}
                            type='primary'
                            style={{ width: '100%' }}
                            loading={this.state.addButtonLoading}
                        >
                            Cadastrar
                        </Button>
                    }
                </Form>
            </div>
        )
    }

}

export default Form.create()(ChampForm)